module.exports = __webpack_public_path__ + "static/img/6.f2e1bfc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/2/sp/6.png
// module id = jHb/
// module chunks = 0